"use client";

import React, { useState } from "react";
import { cn } from "utils";

import { resolveInstitutionLogoSrc } from "./resolveInstitutionLogoSrc";
import type { PlaidInstitutionLogoProps } from "./types";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";

const getInitial = (name?: string): string => {
  const trimmed = name?.trim();
  if (!trimmed) {
    return "?";
  }
  return trimmed.charAt(0).toUpperCase();
};

export const PlaidInstitutionLogo: React.FC<PlaidInstitutionLogoProps> = ({
  institutionName,
  logo,
  className,
  fallbackClassName,
  iconName,
}) => {
  const [imageFailed, setImageFailed] = useState(false);
  const src = resolveInstitutionLogoSrc(logo);
  const showImage = Boolean(src) && !imageFailed;

  return (
    <div
      className={cn(
        "size-8 shrink-0 overflow-hidden rounded-full border border-border_solid",
        className,
      )}
    >
      {showImage ? (
        <img
          src={src}
          alt={institutionName ?? "Institution logo"}
          width={32}
          height={32}
          className="size-full object-cover"
          onError={() => {
            setImageFailed(true);
          }}
        />
      ) : (
        <div
          className={cn(
            "flex size-full items-center justify-center bg-background_white_overlay5 title_s text-content_primary",
            fallbackClassName,
          )}
        >
          {iconName ? (
            <OspIcons
              name={iconName}
              size={16}
              className="shrink-0 text-content_quaternary"
            />
          ) : (
            getInitial(institutionName)
          )}
        </div>
      )}
    </div>
  );
};
